module.exports = __webpack_public_path__ + "img/der_02_coin_b.042efcf8.png";